import { useEffect, useState } from 'react';

import { appendUtmParamsToUrl } from 'shared/utils/url/appendUtmParamsToUrl';
import { getUtmSearchParams } from 'shared/utils/url/getUtmSearchParams';
import { isFpUrl } from 'shared/utils/url/isFpUrl';

export const useUrlWithUtm = (baseUrl: string): string => {
  const [url, setUrl] = useState(baseUrl);

  useEffect(() => {
    if (typeof window === 'undefined' || !isFpUrl(baseUrl)) {
      return;
    }

    const utmParams = getUtmSearchParams(new URL(window.location.href).searchParams);
    setUrl(appendUtmParamsToUrl(baseUrl, utmParams));
  }, [baseUrl]);

  return url;
};
